import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ClientFilterModal = ({ isOpen, onClose, onApplyFilters }) => {
  const [filters, setFilters] = useState({
    searchTerm: '',
    status: '',
    category: '',
    location: '',
    budgetMin: '',
    budgetMax: '',
    lastContactFrom: '',
    lastContactTo: ''
  });

  const handleChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    onApplyFilters?.(filters);
    onClose();
  };

  const handleReset = () => {
    setFilters({
      searchTerm: '',
      status: '',
      category: '',
      location: '',
      budgetMin: '',
      budgetMax: '',
      lastContactFrom: '',
      lastContactTo: ''
    });
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="تصفية العملاء" 
      size="lg"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">بحث</label>
          <Input
            placeholder="ابحث بالاسم، البريد الإلكتروني، أو رقم الهاتف"
            value={filters?.searchTerm}
            onChange={(e) => handleChange('searchTerm', e?.target?.value)}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">الحالة</label>
            <Select
              value={filters?.status}
              onChange={(e) => handleChange('status', e?.target?.value)}
            >
              <option value="">جميع الحالات</option>
              <option value="active">نشط</option>
              <option value="pending">قيد المتابعة</option>
              <option value="inactive">غير نشط</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">الفئة</label>
            <Select
              value={filters?.category}
              onChange={(e) => handleChange('category', e?.target?.value)}
            >
              <option value="">جميع الفئات</option>
              <option value="buyers">مشترون</option>
              <option value="renters">مستأجرون</option>
              <option value="investors">مستثمرون</option>
              <option value="vip">VIP</option>
            </Select>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الموقع المفضل</label>
          <Input
            placeholder="مثال: دبي مارينا، الريم"
            value={filters?.location}
            onChange={(e) => handleChange('location', e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">نطاق الميزانية (دينار أردني)</label>
          <div className="grid grid-cols-2 gap-4">
            <Input
              type="number"
              placeholder="الحد الأدنى"
              value={filters?.budgetMin}
              onChange={(e) => handleChange('budgetMin', e?.target?.value)}
            />
            <Input
              type="number"
              placeholder="الحد الأقصى"
              value={filters?.budgetMax}
              onChange={(e) => handleChange('budgetMax', e?.target?.value)}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ آخر تواصل</label>
          <div className="grid grid-cols-2 gap-4">
            <Input
              type="date"
              value={filters?.lastContactFrom}
              onChange={(e) => handleChange('lastContactFrom', e?.target?.value)}
            />
            <Input
              type="date"
              value={filters?.lastContactTo}
              onChange={(e) => handleChange('lastContactTo', e?.target?.value)}
            />
          </div>
        </div>

        <div className="flex gap-3 pt-4">
          <Button onClick={handleApply} className="flex-1">
            <Icon name="Filter" size={18} className="ml-2" />
            تطبيق التصفية
          </Button>
          <Button onClick={handleReset} variant="outline" className="flex-1">
            <Icon name="RotateCcw" size={18} className="ml-2" />
            إعادة تعيين
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ClientFilterModal;